import { render, staticRenderFns } from "./FlightSelects.vue?vue&type=template&id=12badfb9&scoped=true"
import script from "./FlightSelects.vue?vue&type=script&lang=js"
export * from "./FlightSelects.vue?vue&type=script&lang=js"
import style0 from "./FlightSelects.vue?vue&type=style&index=0&id=12badfb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12badfb9",
  null
  
)

export default component.exports